export enum LinkPanelIconSizes {
  Size24 = 'Size 24',
  Size32 = 'Size 32',
}
